
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageCarousel } from '@/utils/types'
import FlexMessageComponents from '@/components/common/flex-message/FlexMessageComponents.vue'
import FlexMessageBubble from '@/components/common/flex-message/FlexMessageBubble.vue'
import * as htmlToImage from 'html-to-image'
import FlexMessageBubbleTree from '@/components/common/flex-message/FlexMessageBubbleTree.vue'

@Options({
  components: { FlexMessageBubbleTree, FlexMessageBubble, FlexMessageComponents },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode', 'onCaptureMessage', 'update:hoverPath'],
})
export default class FlexMessage extends Vue {
  @Prop()
  type!: string

  @Prop()
  bubbleMessage!: IFlexMessageBubble

  @Prop()
  carouselMessage!: IFlexMessageCarousel

  @Prop()
  hoverPath!: string

  @Prop()
  isChanged!: boolean

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  previewImageUrl = ''
  listNode: string[] = []

  get currentHovePath(): string {
    return this.hoverPath
  }

  set currentHovePath(value: string) {
    this.$emit('update:hoverPath', value)
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.listNode.push(...path)
    this.$emit('initListNode', this.listNode)
  }

  captureMessage() {
    this.currentHovePath = ''

    if (!this.previewImageUrl || this.isChanged) {
      const container = this.$refs.messageView as HTMLElement
      if (!container) return

      let targetNode
      if (this.type === 'bubble') {
        targetNode = container.querySelector('.LyBubble') as HTMLElement
      } else {
        targetNode = container.querySelector('.LySlider') as HTMLElement
      }
      if (!targetNode) return

      const width = targetNode.scrollWidth
      const height = targetNode.scrollHeight

      htmlToImage.toBlob(targetNode, {
        width,
        height,
        pixelRatio: 1,
        style: {
          overflow: 'visible',
          transform: 'scale(1)',
          transformOrigin: 'top left',
          width: `${width}px`,
          height: `${height}px`,
        },
      }).then((blob) => {
        if (!blob) return

        const file = new File([blob], 'message.png', { type: blob.type })

        if (this.previewImageUrl) {
          URL.revokeObjectURL(this.previewImageUrl)
        }
        this.previewImageUrl = URL.createObjectURL(file)

        this.$emit('onCaptureMessage', file, this.previewImageUrl)
      })
    }
  }

  mounted() {
    if (this.type === 'carousel') {
      this.listNode.unshift('carousel')
    }
  }
}
